import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import {PontoApiService} from "../shared/ponto-api.service";
import {pontosQuery, pontosModuleName, tiposPontos} from "../shared/data.service";
import {UtilService} from "../../../shared/services/util.service";
import {PontoDeslocamento} from "../shared/ponto.model";

@Component({
    selector: 'app-ponto-deslocamento-form-list',
    template: require('./ponto-deslocamento-form-list.component.html'),
    styles: [require('./ponto-deslocamento-form-list.component.css')]
})
export class PontoDeslocamentoFormListComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() deslocamentoId: number;

    moduleName: any = pontosModuleName;
    pontoObject: any = {};
    newObject: any = {};
    pontoQuery: any;
    submitted: boolean = false;
    pontoId: string = 'pontoSelect';
    tiposList: any[] = [];

    form2: FormGroup;
    ponto = new FormControl('', Validators.required);
    tipo = new FormControl('', Validators.required);

    constructor(
        private _pontoApiService: PontoApiService,
        private _autocompleteService: AutoCompleteService,
        private _utilService: UtilService,

        private _fb: FormBuilder
    ) {
        this.form2 = _fb.group({
            ponto: this.ponto,
            tipo: this.tipo
        });
    }

    ngOnInit() {
        this.pontoQuery = this._utilService.cloneObject(pontosQuery);
        this.tiposList = this._utilService.cloneObject(tiposPontos);
        this.newItem();
    }

    clickRemove(item: any) {
        let onDelete = (function() {
            this.onRemovePonto(item.id);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            let object: PontoDeslocamento = this._utilService.cloneObject(this.newObject);
            object.pontoId = this.pontoObject.id;
            object.tipo = this.newObject.tipo.Key;
            object.deslocamentoId = this.deslocamentoId;

            this.onAddPonto(object);
        }
    }

    getPontoObject(object: any) {
        this.pontoObject = object;
        this._utilService.setSelectOnFormControl(this.form2, 'ponto', object);
    }

    private newItem() {
        this.newObject = {
            tipo: this.tiposList[0],
            ativo: true
        };
    }

    private onAddPonto(object: PontoDeslocamento) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                Response.ponto = {id: this.pontoObject.id, nome: this.pontoObject.text};
                Response.tipo = this.newObject.tipo;

                this.list.push(Response);

                this.newItem();
                this.pontoObject = {};
                this._autocompleteService.setValueOnSelect2(null, this.pontoId);
                this._utilService.setSelectOnFormControl(this.form2, 'ponto', {});

                this.submitted = false;

                this._utilService.swalMessageAddSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._pontoApiService.onPostPontoDeslocamento(object, onDone);
    }

    private onRemovePonto(objectId: number) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === objectId) {
                        this.list[x].ativo = false;
                        break;
                    }
                }

                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._pontoApiService.onDeletePontoDeslocamento(objectId, onDone);
    }


}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/ponto-deslocamento-form-list/ponto-deslocamento-form-list.component.ts
 **/